<accordion
	[isOpen]="false"
	[title]="'PROMPTUARY.MODAL.WITH_TASK.SUBTITLE' | translate"
	icon="list-check"
>
	<div class="zk-flex zk-flex-col zk-mt-2 zk-gap-2">
		<div *ngIf="description">
			<p id="orientation_title" freud-typography fontType="bodySemibold1-5">
				{{ 'PROMPTUARY.MODAL.WITH_TASK.ORIENTATIONS_TITLE' | translate }}
			</p>
			<p
				id="orientation_text"
				class="orientation__text"
				freud-typography
				fontType="bodyRegular1-2"
			>
				{{ description }}
			</p>
		</div>
		<div div *ngIf="links.length > 0">
			<p id="links_title" freud-typography fontType="bodySemibold1-5">
				{{ 'PROMPTUARY.MODAL.WITH_TASK.LINK_TITLE' | translate }}
			</p>
			<div
				*ngFor="let link of links"
				class="zk-flex zk-flex-col zk-gap-1"
				(click)="preventAccordionToggle($event)"
			>
				<a
					href="{{ link.specifications.url }}"
					target="_blank"
					rel="noopener noreferrer"
					freud-typography
					fontType="bodyRegular1-2"
					>{{ link.specifications.url }}</a
				>
			</div>
		</div>
	</div>
</accordion>
